// extracted by mini-css-extract-plugin
module.exports = {"container":"Footnote_container__3uXJ6","label":"Footnote_label__2_m07 text_text-2__18Lnm"};